import React from "react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { Trash2 } from "lucide-react";

export function ConfirmDialog({ open, onOpenChange, title, description, confirmLabel = "Supprimer définitivement", cancelLabel = "Annuler", onConfirm, destructive = true, testid = "confirm-dialog" }) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="border-zinc-800 bg-zinc-950 text-white" data-testid={testid}>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2 text-white">
            {destructive && <Trash2 className="h-5 w-5 text-red-400" />}{title}
          </AlertDialogTitle>
          {description && <AlertDialogDescription className="text-zinc-400">{description}</AlertDialogDescription>}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={`${testid}-cancel`} className="border-zinc-700 bg-transparent text-zinc-200 hover:bg-zinc-800 hover:text-white">{cancelLabel}</AlertDialogCancel>
          <AlertDialogAction data-testid={`${testid}-confirm`} onClick={onConfirm} className={destructive ? "bg-red-600 text-white hover:bg-red-700" : "bg-[#FF6A00] text-white hover:bg-[#E65F00]"}>{confirmLabel}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export default ConfirmDialog;
